import { CART_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

type SendSMSAPIResponse = { status: boolean; message: any };

export interface ISendSMSData {
  user_id: string;
  order_id: string;
}

export const useSeuseSnapmintPaymentLinkAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: ISendSMSData) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: SendSMSAPIResponse = await axios
          .post(CART_MODULE?.SNAPMINT_PAYMENT_LINK?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              toastNotification(res.data.message);
              return { status: true, message: res.data.data };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
